import React from 'react';
import carImage from '../assets/car.svg';
import { FaGift } from 'react-icons/fa';

const Promotion = () => {
  const promotions = [
    {
      title: 'Discount up to 30%',
      description: 'Special promo valid for economy rides.',
      image: carImage,
    },
    {
      title: 'Discount up to 30%',
      description: 'Special promo valid for standard rides.',
      image: carImage,
    },
  ];

  const coupons = [
    {
      title: '30% OFF',
      description: 'On Completing 30 Rides',
      couponCode: 'DH39HX2B',
    },
    {
      title: '25% OFF',
      description: 'On First Ride',
      couponCode: 'NEW25RIDE',
    },
    {
      title: '50% OFF',
      description: 'On Referral Ride',
      couponCode: 'REFER50TY',
    },
    {
      title: '50% OFF',
      description: 'On Referral Ride',
      couponCode: 'REFER50TY',
    },
  ];

  return (
    <div className='dashboard-container'>
      <div className='content'>
        <div className='card'>
          <div className='p-3 p-sm-5'>
            <div className='row mb-4'>
              <h5
                className='mb-3'
                style={{ fontSize: '22px', fontWeight: '600' }}
              >
                New Promotions
              </h5>
              {promotions.map((promo, index) => (
                <div className='col-lg-6 col-md-6 mb-3' key={index}>
                  <div className='card py-2'>
                    <div
                      className='card-body d-flex justify-content-between align-items-center'
                      style={{
                        border: '1px solid #f37a20',
                        borderRadius: '8px',
                      }}
                    >
                      <div style={{ textAlign: 'left' }}>
                        <h6 style={{ fontWeight: '700' }}>{promo.title}</h6>
                        <p>{promo.description}</p>
                        <button
                          className='btn'
                          style={{
                            backgroundColor: '#f37a20',
                            color: '#fff',
                            textDecoration: 'none',
                            borderRadius: '6px',
                          }}
                        >
                          Redeem Promo
                        </button>
                      </div>
                      <img
                        src={carImage}
                        alt='Car'
                        style={{
                          width: '100%',
                          maxWidth: '110px',
                          height: 'auto',
                        }}
                        className='img-fluid'
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className='row mb-4'>
              <h5
                className='mb-3'
                style={{ fontSize: '22px', fontWeight: '600' }}
              >
                Available Coupons
              </h5>
              {coupons.map((coupon, index) => (
                <div className='col-lg-3 col-md-6 mb-3' key={index}>
                  <div className='card py-2'>
                    <div
                      className='card-body text-center'
                      style={{
                        border: '1px solid #f37a20',
                        borderRadius: '8px',
                      }}
                    >
                      <div className='mb-1 mt-2' style={{ color: '#f37a20' }}>
                        <FaGift size={24} />
                      </div>
                      <p style={{ color: '#7d7878', fontSize: '16px' }}>
                        Surprise gift for you
                      </p>
                      <h6
                        className='mt-3'
                        style={{
                          color: '#f37a20',
                          fontWeight: '800',
                          fontSize: '22px',
                        }}
                      >
                        {coupon.title}
                      </h6>

                      <p
                        className='mb-2'
                        style={{ fontWeight: '500', fontSize: '16px' }}
                      >
                        {coupon.description}
                      </p>
                      <div
                        className='p-2 mb-4'
                        style={{
                          border: '1px dashed #7d7878',
                          borderRadius: '6px',
                        }}
                      >
                        <span style={{ color: '#7d7878' }}>
                          Your coupon code:
                        </span>{' '}
                        <strong>{coupon.couponCode}</strong>
                      </div>

                      <button
                        className='px-3 py-2'
                        style={{
                          backgroundColor: '#f37a20',
                          color: '#fff',
                          textDecoration: 'none',
                          borderRadius: '6px',
                        }}
                      >
                        Redeem Coupon
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Promotion;
